import React, { Component } from 'react';
import { SkubotSpinner } from '@commonsku/styles';

const LOADING_IMG_SRC = '/images/gears.gif';
const NOT_FOUND_IMG_SRC = '/images/404.png';

const DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_ATTEMPT_INTERVAL = 10000;

class Img extends Component {

  constructor(props) {
    super(props);

    this.state = {
      src: this.props.src,
      attempts: 0,
      isLoading: this.props.useSpinner === true,
      spinnerSize: 'medium',
    };

    this.imageContainerRef = React.createRef();
    this.onLoad = this.onLoad.bind(this);
    this.onError = this.onError.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({
        src: nextProps.src,
        attempts: 0,
        isLoading: nextProps.useSpinner === true
      }, () => {
        if (this.props.useSpinner === true) {
          this.setSpinnerSize();
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.retryId) {
      clearTimeout(this.retryId);
    }
  }

  componentDidMount() {
    if (this.props.useSpinner === true) {
      this.setSpinnerSize();
    }
  }

  validImageSrc(src) {
    return typeof src === 'string' && src.trim() !== '';
  }

  setSpinnerSize() {
    const imageContainer = this.imageContainerRef.current;
    if (!imageContainer) {
      return;
    }

    const containerWidth = imageContainer.offsetWidth;
    let spinnerSize;
    if (containerWidth <= 200) {
      spinnerSize = 'tiny';
    } else if (containerWidth <= 400) {
      spinnerSize = 'small';
    } else {
      spinnerSize = 'medium';
    }
    this.setState({ spinnerSize });
  }

  onLoad(e) {
    if (this.props.useSpinner === true) {
      this.setState({ isLoading: false });
    }

    if (this.props.onLoad) {
      this.props.onLoad(e);
    }
  }

  onError() {
    if (this.props.onErrorCallback) {
      this.props.onErrorCallback();
    }
    if (!this.validImageSrc(this.props.src) || NOT_FOUND_IMG_SRC === this.state.src) {
      return;
    }
    const max_attempts = this.props.max_attempts || DEFAULT_MAX_ATTEMPTS;
    const attempt_interval = this.props.attempt_interval || DEFAULT_ATTEMPT_INTERVAL;

    if (this.state.attempts >= max_attempts) {
      this.setState({
        src: NOT_FOUND_IMG_SRC, isLoading: false
      });
      return;
    }

    const nextAttempts = this.state.attempts + 1;
    if (this.props.useSpinner === true) {
      this.setState({
        attempts: nextAttempts
      });
      this.retryId = setTimeout(() => {
        this.setState({ src: `${this.props.src}?retry=${Date.now()}` });
      }, attempt_interval * nextAttempts * nextAttempts);
    } else {
      this.setState({
        src: LOADING_IMG_SRC,
        attempts: nextAttempts
      });
      this.retryId = setTimeout(() => {
        this.setState({ src: this.props.src });
      }, attempt_interval * nextAttempts * nextAttempts);
    }
  }

  render() {
    if (!this.validImageSrc(this.state.src)) {
      return null;
    }

    const props = {
      onError: this.onError,
      ...this.props,
      src: this.state.src,
      onLoad: this.onLoad,
    };

    if (this.props.useSpinner !== true) {
      return (
        <img {...props} />
      );
    }

    return (
      <div ref={this.imageContainerRef} style={{ position: 'relative', height: '100%', width: '100%' }}>
        {this.state.isLoading && <SkubotSpinner
          size={this.state.spinnerSize}
          skubot={false}
          {...(this.props.spinnerColor && { color: this.props.spinnerColor })}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}/>}
        <img
          {...props}
          style={
            this.state.isLoading
              ? { ...props.style, display: 'none' }
              : props.style
          }
        />
      </div>
    );
  }
}

export default Img;
